import { syncTouch } from '../sync/sync.js';

/* ══════════ DB ══════════ */
let db;
/* Nur lesend nach außen: `db` ist ein Import-Binding und darf von anderen
   Modulen nicht überschrieben werden. Gesetzt wird es ausschließlich hier. */
export { db };

/* Beim Start einmal aufrufen – danach steht `db` allen Modulen zur Verfügung. */
export async function initDB() {
  db = await openDB();
  return db;
}

export function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open('karteikarten', 2);
    req.onupgradeneeded = (e) => {
      const d = req.result;
      if (e.oldVersion < 1) {
        d.createObjectStore('courses', { keyPath: 'id' });
        d.createObjectStore('decks', { keyPath: 'id' });
        d.createObjectStore('cards', { keyPath: 'id' });
      }
      if (e.oldVersion < 2) {
        d.createObjectStore('log', { keyPath: 'day' });
        d.createObjectStore('meta', { keyPath: 'key' });
        const store = req.transaction.objectStore('cards');
        store.openCursor().onsuccess = (ev) => {
          const cur = ev.target.result;
          if (!cur) return;
          cur.update(normalizeCard(cur.value));
          cur.continue();
        };
      }
    };
    req.onsuccess = () => {
      const d = req.result;
      d.onversionchange = () => { d.close(); location.reload(); };
      resolve(d);
    };
    req.onerror = () => reject(req.error);
    req.onblocked = () => reject(new Error(
      'Die Karteikarten sind noch in einem anderen Tab oder Fenster offen. Schließ die anderen und lade neu.'
    ));
  });
}

export function normalizeCard(c) {
  const level = c.level || (c.score >= 2 ? 'green' : c.score === 1 ? 'yellow' : 'red');
  return {
    id: c.id, courseId: c.courseId, deckId: c.deckId,
    front: { text: c.front?.text || '', image: c.front?.image || null },
    back: { text: c.back?.text || '', image: c.back?.image || null },
    level,
    streakHard: c.streakHard || 0, streakGood: c.streakGood || 0,
    reps: c.reps || 0, wrong: c.wrong || 0, totalMs: c.totalMs || 0,
    interval: c.interval || 0, due: c.due || 0,
    ease: typeof c.ease === 'number' ? c.ease : 2.5, lapses: c.lapses || 0,
    fav: !!c.fav, later: !!c.later,
    color: Number.isInteger(c.color) ? c.color : 0,
    hint: c.hint || '', tags: Array.isArray(c.tags) ? c.tags : [],
    cloze: !!c.cloze, created: c.created || Date.now(),
  };
}
export const normalizeDeck = (d) => ({ ...d, color: Number.isInteger(d.color) ? d.color : 0, archived: !!d.archived });

export const tx = (store, mode = 'readonly') => db.transaction(store, mode).objectStore(store);
export const dbAll = (s) => new Promise((res, rej) => { const r = tx(s).getAll(); r.onsuccess = () => res(r.result); r.onerror = () => rej(r.error); });
export const dbPut = (s, v) => new Promise((res, rej) => { const r = tx(s, 'readwrite').put(v); r.onsuccess = () => { syncTouch(s); res(v); }; r.onerror = () => rej(r.error); });
export const dbDel = (s, k) => new Promise((res, rej) => { const r = tx(s, 'readwrite').delete(k); r.onsuccess = () => { syncTouch(s); res(); }; r.onerror = () => rej(r.error); });
export const dbGet = (s, k) => new Promise((res, rej) => { const r = tx(s).get(k); r.onsuccess = () => res(r.result); r.onerror = () => rej(r.error); });

